"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaffNotesService = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Api = _interopRequireDefault(require("../Api"));
var _excluded = ["token", "id"],
  _excluded2 = ["token"],
  _excluded3 = ["token"],
  _excluded4 = ["token", "id"],
  _excluded5 = ["token", "id"],
  _excluded6 = ["token", "id"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var StaffNotesService = exports.StaffNotesService = /*#__PURE__*/(0, _createClass2["default"])(function StaffNotesService() {
  (0, _classCallCheck2["default"])(this, StaffNotesService);
});
(0, _defineProperty2["default"])(StaffNotesService, "editStaffNote", function (_ref) {
  var token = _ref.token,
    id = _ref.id,
    params = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return _Api["default"].withAuth(token).patch("/gateNote/".concat(id), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(StaffNotesService, "createStaffNote", function (_ref2) {
  var token = _ref2.token,
    params = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return _Api["default"].withAuth(token).post("/gateNote", _objectSpread({}, params));
});
(0, _defineProperty2["default"])(StaffNotesService, "listNotes", function (_ref3) {
  var token = _ref3.token,
    params = (0, _objectWithoutProperties2["default"])(_ref3, _excluded3);
  return _Api["default"].withAuth(token).get("/gateNote", {
    params: params
  });
});
(0, _defineProperty2["default"])(StaffNotesService, "getStaffNoteById", function (_ref4) {
  var token = _ref4.token,
    id = _ref4.id,
    params = (0, _objectWithoutProperties2["default"])(_ref4, _excluded4);
  return _Api["default"].withAuth(token).get("/gateNote/".concat(id), {
    params: params
  });
});
(0, _defineProperty2["default"])(StaffNotesService, "deleteStaffNote", function (_ref5) {
  var token = _ref5.token,
    id = _ref5.id,
    params = (0, _objectWithoutProperties2["default"])(_ref5, _excluded5);
  return _Api["default"].withAuth(token)["delete"]("/gateNote/".concat(id), {
    params: params
  });
});
(0, _defineProperty2["default"])(StaffNotesService, "expireStaffNote", function (_ref6) {
  var token = _ref6.token,
    id = _ref6.id,
    params = (0, _objectWithoutProperties2["default"])(_ref6, _excluded6);
  return _Api["default"].withAuth(token).post("/gateNote/".concat(id, "/expire"), _objectSpread({}, params));
});